"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSRF = exports.FileUrl = exports.AppUrl = void 0;
let appurl = document.head.querySelector('meta[name="app-url"]');
let fileurl = document.head.querySelector('meta[name="file-url"]');
let token = document.head.querySelector('meta[name="csrf-token"]');
exports.AppUrl = appurl.content;
exports.FileUrl = fileurl.content;
exports.CSRF = token.content;
